// // load scripts
// @codekit-prepend 'libs/slick.min.js';
// @codekit-prepend 'libs/jquery.magnific-popup.min.js'
// @codekit-prepend 'libs/jquery.hoverIntent.minified.js';
// @codekit-prepend 'libs/css3-animate-it.js';
// 'libs/datepicker.min.js';
// 'libs/cookieconsent.min.js';



// // load modules
// @codekit-prepend 'modules/nav.js';

// @codekit-prepend 'modules/slick.js';
// @codekit-prepend 'modules/accordion.js';
// @codekit-prepend 'modules/tabs.js';
// @codekit-prepend 'modules/backtotop.js';
// @codekit-prepend 'modules/videoplayeryoutube.js';
// 'modules/cookie.js';
// 'modules/langswitch.js';

// FOR PREPROS: @prepros-prepend 'modules/slick.js';
// AUSGEBUNDEN 'modules/irgendwas_eigenes.js


$(function(){


// ++ delete me when you're done ++
console.log('main is ready');
	// Formular Condition
	const pmFormRadio = $('.powermail_fieldwrap_materialwirdbenoetigt .powermail_radio');
	const pmFormHidden = $('.powermail_fieldwrap_materialwirdbenoetigt');
	pmFormHidden.next().css('display', 'none');
	pmFormRadio.change(function () {
			if($(this).val() === 'Ja'){
				pmFormHidden.next().fadeIn();
			} else {
				pmFormHidden.next().fadeOut();
			}
		});  
	// Sticky Header on ready
	sticky_relocate();


	// Sticky Header on scroll
	$(window).on('scroll', function(){
		 sticky_relocate();
	});


	// Lightbox magnific Popup for Image
	$('.lightbox').magnificPopup({
		type: 'image',
		gallery: {
			enabled:true
		}
	});

	// Lightbox magnific Popup for iFrame
	$('.popuplightbox').magnificPopup({
		type:'iframe'
	});

	var curLang = $('html').attr('lang');

	switch (curLang) {
		case 'de':
			$.extend(true, $.magnificPopup.defaults, {
				tClose: 'Schließen',
				tLoading: 'Wird geladen...',
				gallery: {
				  tPrev: 'Zurück',
				  tNext: 'Weiter',
				  tCounter: '%curr% von %total%'
				},
				image: {
				  tError: 'Das <a href="%url%">Bild</a> konnte nicht geladen werden.'
				},
				ajax: {
				  tError: 'Der <a href="%url%">Inhalt</a> konnte nicht geladen werden.'
				}
			});
			break;
		default:
		// english already included
	}

	// -> Image Text Tile
	gleicheHoehe('.contacttile-wrapper.three','.contacttile.business','320');
	$( window ).resize(function() {
		gleicheHoehe('.contacttile-wrapper.three','.contacttile.business','320');
	});

	$('.fixedbuttons .btn').each(function() {
		$(this).click(function() {
			$(this).addClass('active');
		});
	});

	// datepicker
	// $('input[type="date"]').attr({
	// 	type: 'text',
	// 	placeholder: 'Datum wählen',
	// 	class: 'datepicker'
	// }).datepicker({
	// 	language: 'de-DE',
	// 	format: 'dd.mm.yyyy'
	// });

	// wrap all powermail fieldwraps with 50% or 33% in a new container
	for(var i = 0; i < $(".width33powermail").length; i+=3) {
	  $(".width33powermail").slice(i, i+3).wrapAll("<div class='powermail_fieldwrap powermail_fieldwrap_width33'></div>");
	}
	for(var i = 0; i < $(".width50powermail").length; i+=2) {
	  $(".width50powermail").slice(i, i+2).wrapAll("<div class='powermail_fieldwrap powermail_fieldwrap_width50'></div>");
	}

	// add a Class to the Table Parent
	$('table.contenttable').parent().addClass('table_container');


});

// Sticky Header Fuction
function sticky_relocate() {
	var window_top = $(window).scrollTop();
	var div_top = $('.sticky-anchor').offset().top;
	if (window_top > div_top) {
		$('.head').addClass('stickyhead');
	} else {
		$('.head').removeClass('stickyhead');
	}
}

// $.fn.datepicker.languages['de-DE'] = {
// 	format: 'dd.mm.yyyy',
// 	days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
// 	daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
// 	daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
// 	weekStart: 1,
// 	months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
// 	monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
// };

// Container gleiche höhe
function gleicheHoehe(cont,el,breakpoint){
	var docWidth = $(document).width();
	var container = $(cont);
	function reset(){
		container.each(function() {
			var sameHeight = $(this).find(el);
			sameHeight.each(function(){
				$(this).css('height', '');
			});
		});
	}
	if(docWidth > breakpoint || breakpoint == undefined)
	{
		reset();
		container.each(function() {
			var sameHeight = $(this).find(el);
			var highestItem = 0;
			sameHeight.each(function(){
				if($(this).outerHeight() > highestItem)
				highestItem = $(this).outerHeight();
			});
			sameHeight.outerHeight(highestItem);
		});
	}
	else
	{
		reset();
	}
}